import { gql } from "@apollo/client"

export const GET_TALENT_MANAGERS = gql`
  query GetTalentManagers($search: String) {
    talent_manager(
      where: {
        _or: [{ company_full_name: { _ilike: $search } }, { first_name: { _ilike: $search } }, { last_name: { _ilike: $search } }]
      }
      order_by: { created_at: desc }
    ) {
      id
      company_full_name
      business_registration_number
      first_name
      last_name
      country
      city
      state
      address
      currency_display
      is_approved
      created_at
      updated_at
      user_id
      user {
        id
        email
        last_login
        created_at
      }
      # KA-1919 — "Connected KOLs" is the number of KOL profiles linked to this talent manager.
      # It must NOT be derived from social_platforms: a KOL is connected the moment
      # talent_manager_id is set, whether or not they have linked a social account. The aggregate
      # also guarantees each KOL counts once even with several linked platforms.
      kol_profiles_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`

// Only the columns the ops roles are allowed to select. Asking for a column they have no
// select permission on makes Hasura reject the whole query ("field not found in type"), which
// react-admin surfaces as "Element does not exist" — the detail page then never opens.
export const GET_TALENT_MANAGER = gql`
  query GetTalentManager($id: uuid!) {
    talent_manager_by_pk(id: $id) {
      id
      company_full_name
      business_registration_number
      first_name
      last_name
      country
      city
      state
      address
      currency_display
      is_approved
      created_at
      updated_at
      user_id
      user {
        id
        email
        last_login
        created_at
      }
    }
  }
`

// Agent's mobile number (KA-1793 / KA-1913). Fetched on its own with errorPolicy "all" so that
// if an environment has not yet applied the select permission for these columns, the query fails
// in isolation and the rest of the detail page still renders. The permission is granted for the
// ops roles in core-service metadata (public_talent_manager.yaml).
export const GET_TALENT_MANAGER_CONTACT = gql`
  query GetTalentManagerContact($id: uuid!) {
    talent_manager_by_pk(id: $id) {
      id
      mobile_number
      mobile_country_code
    }
  }
`

export const UPDATE_TALENT_MANAGER_FIELDS = gql`
  mutation UpdateTalentManagerFields($id: uuid!, $changes: talent_manager_set_input!) {
    update_talent_manager(where: { id: { _eq: $id } }, _set: $changes) {
      returning {
        id
      }
      affected_rows
    }
  }
`

export const UPDATE_TALENT_MANAGER = gql`
  mutation UpdateTalentManager($id: uuid!, $is_approved: Boolean) {
    update_talent_manager(where: { id: { _eq: $id } }, _set: { is_approved: $is_approved }) {
      returning {
        id
        is_approved
      }
      affected_rows
    }
  }
`
